
<div #privacyPage id="privacyPage" class="page">


  <h1 data-translate="PRIVACY_POLICY.TITLE"></h1>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION1.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION1.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION2.HEADING"></h2>
  <p>
    <strong data-translate="PRIVACY_POLICY.SECTION2.NAME"></strong><br>
    <span data-translate="PRIVACY_POLICY.SECTION2.ROLE"></span><br>
    <span data-translate="PRIVACY_POLICY.SECTION2.ADDRESS.LINE1"></span><br>
    <span data-translate="PRIVACY_POLICY.SECTION2.ADDRESS.LINE2"></span><br>
    <span data-translate="PRIVACY_POLICY.SECTION2.ADDRESS.COUNTRY"></span><br>
    <a href="mailto:{{ translate.instant('PRIVACY_POLICY.SECTION2.EMAIL') }}">
      <span data-translate="PRIVACY_POLICY.SECTION2.EMAIL"></span>
    </a>
  </p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION3.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION3.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION4.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION4.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION5.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION5.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION6.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION6.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION7.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION7.CONTENT"></p>
<br>
  <h2 data-translate="PRIVACY_POLICY.SECTION8.HEADING"></h2>
  <p data-translate="PRIVACY_POLICY.SECTION8.CONTENT"></p>
</div>
